import React from 'react';
import { getStripeConnectStatus } from '../../utils/stripeConnectStatus';

const StripeConnectStatusBadge = ({ connect, className = '', showPayoutReady = true }) => {
  const status = getStripeConnectStatus(connect);

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${status.className} ${className}`}
      title={status.accountId || undefined}
    >
      Connect · {status.label}
      {showPayoutReady && status.payoutReady ? ' · payout ready' : ''}
    </span>
  );
};

export default StripeConnectStatusBadge;
